import { inject, Injectable } from "@angular/core";
import { AlertService } from "features";
import { UiKitToasterService } from "@jack-sparrow-libraries/ui-kit";

@Injectable({
	providedIn: "root",
})
// Ce service surcharge les popup chiantes ionic de mobile qui se produisent suites aux erreurs des effets de socle mobile
export class CustomAlertService extends AlertService {
	private readonly toasterService = inject(UiKitToasterService);

	override async inform(options: { header: string; message: string }) {
		this.toasterService.show({ titre: options.header, subtitle: options.message, color: "default" });
	}

	override async alertError(message: string, titre: string) {
		this.toasterService.show({ titre, subtitle: message, color: "alert" });
	}
}
